window.productSelectCallback = function (parameters) {
  // parameters: { variant, money_format, selector, product }
  var variant = parameters.variant;
  var money_format = parameters.money_format;
  var selector = parameters.selector;
  var product = parameters.product;
  var bundleProducts = parameters.bundleProducts;
  var isBundle = bundleProducts && bundleProducts.length;

  if (variant) {
    var compare_at_price = variant.compare_at_price;
    var available = variant.available;
    var price = variant.price;
    const formatted_price = Shopify.formatMoney(price, money_format);
    const formatted_compare = Shopify.formatMoney(
      compare_at_price,
      money_format
    );

    const form = jQuery('#' + selector.domIdPrefix).closest('form');

    $('.js-product-price').each(function () {
      $(this).html(formatted_price);
    });
    $('.js-compare-at-price').each(function () {
      $(this).html(formatted_compare);
    });

    // Change Button Text and disable
    if (!isBundle) {
      if (available) {
        $('#add-to-cart').prop('disabled', false);
        $('#add-to-cart span').html('Add To Bag');
      } else {
        $('#add-to-cart').prop('disabled', true);
        $('#add-to-cart span').html('Out of Stock');
      }
    }

    // Go to matching slide from swatch click

    if (variant.featured_image) {
      var scaleImageSize = function (path, size) {
        var validateImage = function (str) {
          var imageTypes = [
            'jpeg',
            'JPEG',
            'JPG',
            'jpg',
            'png',
            'PNG',
            'TIFF',
            'tiff',
            'GIF',
            'gif',
            'BMP',
            'bmp',
            'PSD',
            'psd',
            'PDF',
            'pdf',
            'eps',
            'EPS'
          ];
          return (
            imageTypes.find(function (type) {
              return str.includes(type);
            }) || null
          );
        };

        var potentialImageType = validateImage(path);

        if (!potentialImageType) {
          return console.error('Failed to find valid image type');
        }

        var parts = path.split('.' + potentialImageType);

        if (parts[2]) {
          return console.error(
            'Failed to properly split asset using .${fileType} as delimiter'
          );
        }

        return parts[0] + '_' + size + '.' + potentialImageType + parts[1];
      };

      $('.product-images-nav li div').each(function () {
        var feat = scaleImageSize(variant.featured_image.src, '150x');
        var bg = $(this).css('background-image');
        bg = bg.split('?v=')[0];
        feat = feat.split('?v=')[0];

        if (bg.indexOf(feat) > -1) {
          $('.product-images-slider').slick(
            'slickGoTo',
            $(this).parent().index()
          );
        }
      });
    }

    // Swatches
    if (!isBundle) {
      for (var i = 0, length = variant.options.length; i < length; i++) {
        var radioButton = form.find(
          '.swatch[data-option-index="' +
            i +
            '"] :radio[value="' +
            variant.options[i] +
            '"]'
        );

        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }

      // Change selected labels
      $('.swatch :radio:checked').each(function () {
        let label = $(this).val();
        let labell = label.toLowerCase();

        if (labell == 's') {
          label = 'Small';
        } else if (labell == 'm') {
          label = 'Medium';
        } else if (labell == 'l') {
          label = 'Large';
        } else if (labell == 'xl') {
          label = 'X-large';
        } else if (labell == '2xl') {
          label = 'XX-large';
        } else if (labell == '3xl') {
          label = 'XXX-large';
        }

        $(this).closest('.swatch').find('.swatch-selected').text(label);
      });
    }
  }
};

/* Swatches for sold out */
$(function () {
  $('.swatch :radio').change(function (e) {
    var radioValue = $(this).val();
    if ($(e.target).parents('.swatch')[0].dataset.optionIndex === '0') {
      optionValue = e.target.value;
    } else {
      var getOption = document.getElementsByName('option-0');

      for (var i = 0; i < getOption.length; i++) {
        if (getOption[i].checked) {
          optionValue = getOption[i].value;
        }
      }
    }
    // js-pdp-swatch to avoid collision with pdp recommended product card's .swatch class
    var swatchGroups = document.getElementsByClassName('js-pdp-swatch');
    if (swatchGroups && swatchGroups.length > 1) {
      for (var i = 1; i < swatchGroups.length; i++) {
        var targetRadioBtns = document.getElementsByName('option-' + i);
        var selectedRadioBtn;

        for (var j = 0; j < targetRadioBtns.length; j++) {
          if (targetRadioBtns[j].checked) {
            selectedRadioBtn = targetRadioBtns[j];
          }
        }

        var dataValue = selectedRadioBtn.dataset.wrapperLookup;
        var option_1_selector = document.querySelector(
          '[data-option="option1"]'
        );
        var option_var_selector = document.querySelector(
          '[data-option="option' + (i + 1) + '"]'
        );

        option_1_selector.value = optionValue;
        $(option_1_selector).trigger('change');

        option_var_selector.value = selectedRadioBtn.value;
        $(option_var_selector).trigger('change');

        var newChecked = document.querySelector(
          '[data-value="' + dataValue + '"]'
        ).firstElementChild;
        newChecked.checked = 'true';
      }
    } else if (swatchGroups && swatchGroups.length == 1) {
      var option_1_selector = document.querySelector('[data-option="option1"]');
      $('[data-option="option1"]').val(radioValue).trigger('change');
    }
  });
  $(document).on('click', '.soldout-cross', function () {
    $(this).siblings('label').trigger('click');
  });
});

/* Gallery */
function initProductSlider() {
  $('.product-images-slider').slick({
    arrows: false,
    mobileFirst: true,
    dots: true,
    slidesToScroll: 1,
    adaptiveHeight: true,
    swipe: true,
    fade: false,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          swipe: false,
          fade: true
        }
      }
    ]
  });

  $('.product-images-nav li:first-child').addClass('active');

  // Update nav on dot click
  $('.product-images-slider').on(
    'beforeChange',
    function (event, slick, currentSlide, nextSlide) {
      $('.product-images-nav li').removeClass('active');
      $('.product-images-nav li').eq(nextSlide).addClass('active');
    }
  );

  // Change on nav click
  $('.product-images-nav li').on('click', function () {
    $('.product-images-nav li').removeClass('active');
    $(this).addClass('active');
    $('.product-images-slider').slick('slickGoTo', $(this).index());
  });

  // Change on nav hover
  $('.product-images-nav li').on('mouseenter', function () {
    $('.product-images-nav li').removeClass('active');
    $(this).addClass('active');
    $('.product-images-slider').slick('slickGoTo', $(this).index());
  });
}
if ($('.product-images-slider').length) {
  initProductSlider();
}

$(document).ready(function () {
  $('.product-image-zoom').each(function () {
    $(this).zoom({
      url: $(this).data('zoom-img'),
      touch: false
    });
  });
});

$(document).ready(function () {
  $.fn.showFlex = function () {
    this.css('display', 'flex');
  };
  var $nav = $('.product-images-nav');
  var $prevButton = $('.scroll-control--prev');
  var $nextButton = $('.scroll-control--next');
  // initial button show
  if (
    $nav.prop('scrollWidth') &&
    $nav.innerWidth() < $nav.prop('scrollWidth')
  ) {
    $nextButton.showFlex();
  }

  function canScroll(direction) {
    switch (direction) {
      case 'left':
        return $nav.scrollLeft() > 0;
      case 'right':
        return $nav.prop('scrollWidth') - $nav.innerWidth() > $nav.scrollLeft();
    }
  }
  function scroll(direction) {
    var options;
    switch (direction) {
      case 'left':
        options = { scrollLeft: '-=300px' };
        break;
      case 'right':
        options = { scrollLeft: '+=300px' };
        break;
    }
    $nav.animate(options, 'fast');
  }
  function handleHorizontalScroll() {
    if (canScroll('left')) {
      $prevButton.showFlex();
    } else {
      $prevButton.hide();
    }
    if (canScroll('right')) {
      $nextButton.removeClass('disabled');
      $nextButton.showFlex();
    } else {
      $nextButton.hide();
    }
  }
  $nav.on('scroll', function () {
    handleHorizontalScroll();
  });
  $prevButton.on('click', function () {
    scroll('left');
  });
  $nextButton.on('click', function () {
    scroll('right');
  });
});

// cdp event
const productJSON = JSON.parse(
  document.getElementById('product-json').innerHTML
);
if (productJSON) sendCDPProductViewedEvent(productJSON);
